"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRelatedPages = exports.getSearcherInfo = exports.initPagesSearchApiListener = exports.initAvSearchApiListener = void 0;
/* eslint-disable no-loop-func */
/* eslint-disable prefer-destructuring */
/* eslint-disable consistent-return */
/* eslint-disable require-yield */
const effects_1 = require("redux-saga/effects");
const redux_saga_1 = require("redux-saga");
const reducers_header_reducer_1 = require("@/bit/reducers/reducers.header-reducer");
const utils_common_get_device_kind_depends_on_viewport_1 = __importDefault(require("@gcloud-npm/utils.common.get-device-kind-depends-on-viewport"));
const utils_secure_local_storage_1 = __importDefault(require("@gcloud-npm/utils.secure.local-storage"));
const secureStorage = new utils_secure_local_storage_1.default();
let DEVICE_MAX_RESULTS = 8;
let PAGES_MAX_RESULTS = 4;
let SERVICES_MAX_RESULTS = 4;
const contextFromStore = (state) => state.main.context;
const searchEngines = {
    pages: null,
    asistente: null,
};
const normalizerQuery = (queryStr) => {
    let res = queryStr.toLowerCase();
    res = res.replace(/á/g, "a");
    res = res.replace(/é/g, "e");
    res = res.replace(/í/g, "i");
    res = res.replace(/ó/g, "o");
    res = res.replace(/ú/g, "u");
    return res;
};
const makeUpCustomObjectsArray = (object) => {
    const res = [];
    Object.keys(object).forEach((key) => {
        const item = object[key];
        const newItem = Object.assign({ path: key, id: key, normalizedName: item.name ? normalizerQuery(item.name) : "", normalizedFilter: item.filter ? normalizerQuery(item.filter) : "" }, item);
        if (item && item.category && item.category.indexOf("novedades") !== -1) {
            res.unshift(newItem);
        }
        else {
            res.push(newItem);
        }
    });
    return res;
};
const normalizeCategoryOptions = (categoryOptions) => {
    const res = {};
    Object.keys(categoryOptions).forEach((keyName) => {
        const currentItem = categoryOptions[keyName];
        const { title: label, url: pathName } = currentItem;
        const newItem = {
            key: keyName,
            id: keyName,
            label,
            pathName,
            kind: "page",
        };
        res[keyName] = newItem;
    });
    return res;
};
let searchApi = null;
let Search = null;
function* createSearchEngine(info, props = {
    fieldNamesOrIndexFunction: [
        "name",
        "path",
        "brand",
        "storage",
        "category",
        "color",
        "normalizedName",
        "normalizedFilter",
        "filter",
        "allProductsName",
    ],
    resourceName: "pages",
}) {
    try {
        return (0, redux_saga_1.eventChannel)((emitter) => {
            const iv = 0;
            const { resourceName } = props;
            searchEngines[resourceName] = new searchApi.default({ Search });
            searchEngines[resourceName].indexResource(Object.assign(Object.assign({}, props), { resources: info }));
            searchEngines[resourceName].subscribe((data) => {
                emitter(data);
            }, (error) => {
                console.log(error);
            });
            // The subscriber must return an unsubscribe function, but it will never happen
            return () => {
                clearInterval(iv);
            };
        });
    }
    catch (error) {
        console.log(error);
    }
}
function* initAvSearchApiListener(avList) {
    try {
        const chan = yield (0, effects_1.call)(createSearchEngine, avList, {
            fieldNamesOrIndexFunction: ["normalizedName"],
            resourceName: "asistente",
        });
        while (true) {
            const info = yield (0, effects_1.take)(chan);
            const { result } = info;
            const querySuggestedInputs = result.slice(0, 3).map((item) => {
                const newItem = {
                    label: item,
                    kind: "av",
                };
                return newItem;
            });
            yield (0, effects_1.put)(reducers_header_reducer_1.actions.setSuggestedInputs({
                querySuggestedInputs: [...querySuggestedInputs],
            }));
            // hacemos la logica de suggested
            // yield call(getSuggestedInputs, query, categoriesMatched);
        }
    }
    catch (error) {
        console.error(error);
    }
}
exports.initAvSearchApiListener = initAvSearchApiListener;
function* initPagesSearchApiListener(pagesList) {
    var _a, _b;
    try {
        const chan = yield (0, effects_1.call)(createSearchEngine, pagesList);
        while (true) {
            const info = yield (0, effects_1.take)(chan);
            const { result, text: query } = info;
            const pagesList = yield (0, effects_1.select)((state) => state.header.pagesList);
            const categoryOptions = yield (0, effects_1.select)((state) => state.header.categoryOptions);
            const categoriesMatched = [];
            const mappedResults = {
                devices: [],
                regular: [],
                services: [],
            };
            const persistedInfo = secureStorage.getItem("ts");
            const clientType = ((_a = persistedInfo === null || persistedInfo === void 0 ? void 0 : persistedInfo.userPq) === null || _a === void 0 ? void 0 : _a.clt) && `${(_b = persistedInfo === null || persistedInfo === void 0 ? void 0 : persistedInfo.userPq) === null || _b === void 0 ? void 0 : _b.clt}`;
            const shouldRenderR2R = clientType === "4" ||
                clientType === "5" ||
                clientType === "0" ||
                !clientType;
            const device = (0, utils_common_get_device_kind_depends_on_viewport_1.default)();
            if (device === "MOBILE") {
                DEVICE_MAX_RESULTS = 8;
                PAGES_MAX_RESULTS = 4;
                SERVICES_MAX_RESULTS = 2;
            }
            // for clasico para limitar la busqueda
            let cndStop = false;
            for (let i = 0; !cndStop && i < result.length; i++) {
                const itemFounded = result[i];
                const item = Object.assign({ key: itemFounded, pathName: itemFounded }, pagesList[itemFounded]);
                const isDevice = item && item.brand;
                const isService = item && item.products;
                let cndMaxDevice = mappedResults.devices.length < DEVICE_MAX_RESULTS;
                let cndMaxService = mappedResults.services.length < SERVICES_MAX_RESULTS;
                const cndMaxPages = mappedResults.regular.length < PAGES_MAX_RESULTS;
                if (isDevice) {
                    // almacenamos categoria encontrada
                    const deviceCategories = item.category && item.category ? item.category.split(",") : [];
                    if (deviceCategories && Array.isArray(deviceCategories)) {
                        deviceCategories.forEach((currentCategory) => {
                            const noAlreadyPushed = categoriesMatched.find((category) => category && category.id === currentCategory);
                            if (!noAlreadyPushed) {
                                const existCategory = categoryOptions && categoryOptions[currentCategory];
                                if (existCategory) {
                                    categoriesMatched.push(existCategory);
                                }
                            }
                        });
                    }
                    let currentItem = null;
                    if (cndMaxDevice) {
                        if (shouldRenderR2R &&
                            typeof item.pvpRTRDesde !== "undefined" &&
                            item.pvpRTRDesde > -1) {
                            currentItem = Object.assign(Object.assign({}, item), { key: `${item.key}.min`, prePrice: "Desde", unity: "€/mes", amount: item.pvpRTRDesde });
                        }
                        if (!currentItem &&
                            typeof item.minPrice !== "undefined" &&
                            item.minPrice > -1) {
                            currentItem = Object.assign(Object.assign({}, item), { key: `${item.key}.min`, prePrice: "Por", unity: "€", amount: item.minPrice });
                        }
                    }
                    if (currentItem) {
                        mappedResults.devices.push(currentItem);
                        cndMaxDevice = mappedResults.devices.length < DEVICE_MAX_RESULTS;
                    }
                }
                else if (isService) {
                    if (item && item.products) {
                        item.products.forEach((product) => {
                            if (cndMaxService) {
                                const smallItem = Object.assign(Object.assign({}, item), product);
                                smallItem.amount = smallItem.price;
                                delete smallItem.price;
                                delete smallItem.products;
                                const exist = mappedResults.services.findIndex((item) => item.name === smallItem.name);
                                if (exist === -1) {
                                    mappedResults.services.push(smallItem);
                                    cndMaxService =
                                        mappedResults.services.length < SERVICES_MAX_RESULTS;
                                }
                            }
                        });
                    }
                }
                else if (cndMaxPages) {
                    mappedResults.regular.push(item);
                }
                // analizo si termino
                if (!cndMaxDevice && !cndMaxService && !cndMaxPages) {
                    cndStop = true;
                    break;
                }
            }
            // ordena las estructuras por precio
            mappedResults.devices.sort((itemA, itemB) => {
                const alphabetically = itemA.name - itemB.name;
                if (alphabetically !== 0) {
                    return alphabetically;
                }
                return parseInt(itemA.amount, 10) - parseInt(itemB.amount, 10);
            });
            mappedResults.services.sort((itemA, itemB) => {
                return parseInt(itemA.amount, 10) - parseInt(itemB.amount, 10);
            });
            // hariamos los put de results
            yield (0, effects_1.put)(reducers_header_reducer_1.actions.setRelatedPages({
                pagesList: mappedResults,
                categoriesMatched,
                inputQuery: query,
            }));
        }
    }
    catch (error) {
        console.error(error);
    }
}
exports.initPagesSearchApiListener = initPagesSearchApiListener;
let allInfo = null;
function* getSearcherInfo() {
    // Trocear trycatch por peti
    try {
        let infoSearcher = null;
        // vemos si ya tenemos la info
        let pagesList = null;
        let categoryOptions = null;
        let pagesListMapped = null;
        let suggestedInputs = null;
        let pagesNoResults = null;
        infoSearcher = {};
        // buscamos toda la info que necesitamos
        const context = yield (0, effects_1.select)(contextFromStore);
        const { pageSegment: segment } = context;
        if (!allInfo) {
            const infoNeeded = yield (0, effects_1.all)([
                (0, effects_1.call)(() => Promise.resolve().then(() => __importStar(require("js-worker-search")))),
                (0, effects_1.call)(() => Promise.resolve().then(() => __importStar(require("@gcloud-npm/utils.search-api")))),
                (0, effects_1.call)(() => Promise.resolve().then(() => __importStar(require("@gcloud-npm/adabyron.custo.get-searcher-info")))),
            ]);
            Search = infoNeeded[0].default;
            searchApi = infoNeeded[1];
            let getAllSearchInfo = infoNeeded[2];
            getAllSearchInfo = getAllSearchInfo.default;
            allInfo = yield (0, effects_1.call)(getAllSearchInfo, { segment, context });
            // ME QUEDO CON LOS DATOS
            if (allInfo && allInfo.av) {
                suggestedInputs = allInfo.av.map((item, index) => {
                    return {
                        key: index,
                        id: item,
                        normalizedName: normalizerQuery(item),
                    };
                });
            }
            if (allInfo && allInfo.categoryOptions) {
                categoryOptions = normalizeCategoryOptions(allInfo.categoryOptions);
            }
            if (allInfo && allInfo.paths) {
                pagesListMapped = allInfo.paths;
                pagesList = makeUpCustomObjectsArray(allInfo.paths);
            }
            /*
            if (allInfo && allInfo.noResults) {
              pagesNoResults = allInfo.noResults;
            } */
            pagesNoResults = allInfo.noResults;
            // guardamos en session
            infoSearcher.pagesList = pagesListMapped;
            infoSearcher.suggestedInputs = suggestedInputs;
            infoSearcher.pagesNoResults = pagesNoResults;
            yield (0, effects_1.put)(reducers_header_reducer_1.actions.setSearcherInfo({
                pagesList: infoSearcher.pagesList,
                suggestedInputs,
                categoryOptions,
                pagesNoResults: infoSearcher.pagesNoResults,
            }));
            // inicializamos apis buscador de paginas => yield all
            // inicializo apis buscador de av
            yield (0, effects_1.all)([
                (0, effects_1.call)(initAvSearchApiListener, suggestedInputs),
                (0, effects_1.call)(initPagesSearchApiListener, pagesList),
            ]);
        }
    }
    catch (error) {
        console.log(error);
    }
    return searchEngines;
}
exports.getSearcherInfo = getSearcherInfo;
function* getRelatedPages({ query }) {
    try {
        const normalizedQuery = normalizerQuery(query);
        if (searchEngines && searchEngines.pages && searchEngines.asistente) {
            searchEngines.pages.performSearch("pages", normalizedQuery);
            searchEngines.asistente.performSearch("asistente", normalizedQuery);
        }
    }
    catch (error) {
        console.log(error);
    }
}
exports.getRelatedPages = getRelatedPages;
exports.default = getSearcherInfo;
//# sourceMappingURL=index.js.map